<template>
	<CommonHeader class="main_head_block">
		<template v-slot:header>

			<span class="module_heading" style="width:auto">Templates</span>
			<i class="fas fa-plus icon_one" @click = "addNewTemplate()"></i>

			<div class="sel_fil_wrap one">
				<multiselect
					v-model="selectedTempOwner"
					:options="ownerTempList"
					:show-no-results="true"
					ref="multiselect"
					label="type"
					track-by="id"
					open-direction="bottom"
					:taggable="false"
					placeholder="Owner"
					class="form-control multi-dropdown select_filter"
					selectLabel = ""
					deselectLabel = ""
					@select = "selectOwner"
					@remove = "resetOwner()"
					/>
			</div>
			</template>
	</CommonHeader>
</template>

<script>
import Multiselect from "vue-multiselect";
import CommonHeader from "@/components/CommonHeader.vue"
export default {
	name: "TemplateHeader",
	components:{ Multiselect, CommonHeader},
	data(){
		return{
			ownerTempList:[
				{
					type:"Me",
					id:"Me"
				},
				{
					type:"All",
					id:"All"
				}
			],
			selectedTempOwner:{
				type:"Me",
				id:"Me"
			},
		}
	},
	mounted(){
		if(this.$store.state.template.tempOwner == 'Me'){
			this.selectedTempOwner = {
				type:"Me",
				id:"Me"
			}
		}
		else if(this.$store.state.template.tempOwner == 'All'){
			this.selectedTempOwner = {
				type:"All",
				id:"All"
			}
		}
	},
	methods:{
		addNewTemplate(){
			this.$router.push({
				path: "/addTemplate"
			});
		},
		selectOwner(data){
			if(data.type == 'Me'){
				this.$store.state.template.tempOwner = 'Me';
				this.$emit('getList')
			}
			else{
				this.$store.state.template.tempOwner = 'All';
				this.$emit('getList')
			}
			
		},
		resetOwner(){
			this.$store.state.template.tempOwner = '';
			this.$emit('getList')
		},
	}
}
</script>
